import { render, staticRenderFns } from "./AdminEbOptionsEdit.vue?vue&type=template&id=9f84e806&scoped=true"
import script from "./AdminEbOptionsEdit.vue?vue&type=script&lang=js"
export * from "./AdminEbOptionsEdit.vue?vue&type=script&lang=js"
import style0 from "./AdminEbOptionsEdit.vue?vue&type=style&index=0&id=9f84e806&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f84e806",
  null
  
)

export default component.exports